import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faUser, faTimes, faCalendarAlt, faTrash, faEye, faEdit } from '@fortawesome/free-solid-svg-icons';


const UserIcon = ({ size, className }) => {
    return (
        <div className="user-info">
            <FontAwesomeIcon icon={faUser} size={size} className={className} />
            <span><strong>Welcome Username</strong></span>
        </div>
    );
};

const CloseIcon = ({ size, className }) => {
    return (
        <div className="close-icon">
            <FontAwesomeIcon icon={faTimes} size={size} className={className} />
        </div>
    );
};

const FaCalendar = () => {
    return (
        <FontAwesomeIcon icon={faCalendarAlt} />
    );
};

const FaDelete = () => {
    return (
        <FontAwesomeIcon icon={faTrash} /> // Use the `faTrash` icon
    );
};

const FaView = ({size, className}) => {
    return (
        <FontAwesomeIcon icon={faEye} size={size} className={className} /> // Use the `faEye` icon
    );
};

const FaEdit = ({size, className}) => {
    return (
        <FontAwesomeIcon icon={faEdit} size={size} className={className} /> // Use the `faEye` icon
    );
};




export { UserIcon, CloseIcon, FaCalendar, FaDelete, FaView, FaEdit };
